import { z } from 'zod';
import { jobStateValues } from 'src/apis/transparency-reporting/mappings';
import { getPaginationSchema } from 'src/components/form/zod-schemas';
import { preprocessAsBoolean } from 'src/components/form/zod-utilities';
import { usePageParamsFromSchema } from 'src/hooks/use-page-params-from-schema';

export function useJobsPageParams() {
  return usePageParamsFromSchema(getJobsSearchParamsSchema(), {
    filters: {
      name: { label: 'Job Name' },
      state: { label: 'State' },
    },
  });
}

export type JobsPageParams = ReturnType<typeof useJobsPageParams>;

function getJobsSearchParamsSchema() {
  return z.object({
    sortColumn: z.string().default('jobName'),
    sortAscending: z.preprocess(preprocessAsBoolean, z.boolean().default(true)),
    name: z.string().nullable().default(null),
    state: z.enum(jobStateValues).nullable().default(null),
    ...getPaginationSchema().shape,
  });
}
